// Mock data for agricultural analytics dashboard
export const provinces = [
  { id: 'ON', name: 'Ontario', center: [44.2619, -78.2624] },
  { id: 'SK', name: 'Saskatchewan', center: [52.9399, -106.4509] },
  { id: 'AB', name: 'Alberta', center: [53.9333, -116.5765] },
  { id: 'MB', name: 'Manitoba', center: [53.7609, -98.8139] }
];

export const crops = ['Wheat', 'Canola', 'Corn', 'Soybeans'];

// Weather data for the last 10 years (2015-2024)
export const weatherData = {
  ON: {
    temperature: [
      { year: 2015, avg: 8.2, min: -12.3, max: 31.4 },
      { year: 2016, avg: 8.9, min: -10.1, max: 33.2 },
      { year: 2017, avg: 7.8, min: -14.5, max: 30.1 },
      { year: 2018, avg: 9.1, min: -8.9, max: 34.3 },
      { year: 2019, avg: 8.5, min: -11.2, max: 32.7 },
      { year: 2020, avg: 9.3, min: -7.6, max: 35.1 },
      { year: 2021, avg: 8.7, min: -9.8, max: 33.8 },
      { year: 2022, avg: 9.8, min: -6.4, max: 36.2 },
      { year: 2023, avg: 8.9, min: -8.7, max: 34.5 },
      { year: 2024, avg: 9.2, min: -7.1, max: 35.6 }
    ],
    precipitation: [
      { year: 2015, total: 783, growing: 421 },
      { year: 2016, total: 812, growing: 445 },
      { year: 2017, total: 698, growing: 378 },
      { year: 2018, total: 889, growing: 501 },
      { year: 2019, total: 745, growing: 412 },
      { year: 2020, total: 823, growing: 456 },
      { year: 2021, total: 756, growing: 423 },
      { year: 2022, total: 702, growing: 389 },
      { year: 2023, total: 834, growing: 467 },
      { year: 2024, total: 798, growing: 441 }
    ]
  },
  SK: {
    temperature: [
      { year: 2015, avg: 2.3, min: -28.4, max: 32.1 },
      { year: 2016, avg: 3.1, min: -26.7, max: 34.2 },
      { year: 2017, avg: 1.9, min: -31.2, max: 30.8 },
      { year: 2018, avg: 3.8, min: -24.3, max: 35.6 },
      { year: 2019, avg: 2.7, min: -27.9, max: 33.4 },
      { year: 2020, avg: 4.1, min: -22.8, max: 36.7 },
      { year: 2021, avg: 3.2, min: -25.6, max: 34.9 },
      { year: 2022, avg: 4.7, min: -21.2, max: 38.3 },
      { year: 2023, avg: 3.5, min: -24.1, max: 35.8 },
      { year: 2024, avg: 3.9, min: -22.6, max: 37.2 }
    ],
    precipitation: [
      { year: 2015, total: 386, growing: 278 },
      { year: 2016, total: 412, growing: 295 },
      { year: 2017, total: 323, growing: 234 },
      { year: 2018, total: 445, growing: 321 },
      { year: 2019, total: 378, growing: 267 },
      { year: 2020, total: 423, growing: 304 },
      { year: 2021, total: 356, growing: 251 },
      { year: 2022, total: 289, growing: 201 },
      { year: 2023, total: 467, growing: 334 },
      { year: 2024, total: 398, growing: 286 }
    ]
  },
  AB: {
    temperature: [
      { year: 2015, avg: 3.8, min: -25.2, max: 30.9 },
      { year: 2016, avg: 4.6, min: -23.1, max: 32.8 },
      { year: 2017, avg: 3.2, min: -27.8, max: 29.4 },
      { year: 2018, avg: 5.1, min: -21.6, max: 34.2 },
      { year: 2019, avg: 4.3, min: -24.3, max: 31.7 },
      { year: 2020, avg: 5.7, min: -19.8, max: 35.4 },
      { year: 2021, avg: 4.8, min: -22.1, max: 33.6 },
      { year: 2022, avg: 6.2, min: -18.4, max: 37.1 },
      { year: 2023, avg: 5.1, min: -20.7, max: 34.8 },
      { year: 2024, avg: 5.5, min: -19.2, max: 36.3 }
    ],
    precipitation: [
      { year: 2015, total: 456, growing: 312 },
      { year: 2016, total: 489, growing: 335 },
      { year: 2017, total: 398, growing: 267 },
      { year: 2018, total: 523, growing: 367 },
      { year: 2019, total: 445, growing: 301 },
      { year: 2020, total: 501, growing: 343 },
      { year: 2021, total: 423, growing: 289 },
      { year: 2022, total: 356, growing: 234 },
      { year: 2023, total: 534, growing: 378 },
      { year: 2024, total: 478, growing: 321 }
    ]
  },
  MB: {
    temperature: [
      { year: 2015, avg: 2.8, min: -26.7, max: 30.4 },
      { year: 2016, avg: 3.6, min: -24.2, max: 32.1 },
      { year: 2017, avg: 2.1, min: -29.3, max: 28.9 },
      { year: 2018, avg: 4.3, min: -22.8, max: 33.7 },
      { year: 2019, avg: 3.2, min: -25.6, max: 31.3 },
      { year: 2020, avg: 4.8, min: -21.4, max: 34.9 },
      { year: 2021, avg: 3.7, min: -23.9, max: 32.6 },
      { year: 2022, avg: 5.3, min: -19.7, max: 36.2 },
      { year: 2023, avg: 4.1, min: -22.3, max: 33.8 },
      { year: 2024, avg: 4.6, min: -20.8, max: 35.4 }
    ],
    precipitation: [
      { year: 2015, total: 512, growing: 356 },
      { year: 2016, total: 548, growing: 382 },
      { year: 2017, total: 445, growing: 301 },
      { year: 2018, total: 589, growing: 423 },
      { year: 2019, total: 501, growing: 345 },
      { year: 2020, total: 567, growing: 398 },
      { year: 2021, total: 489, growing: 334 },
      { year: 2022, total: 423, growing: 289 },
      { year: 2023, total: 598, growing: 434 },
      { year: 2024, total: 534, growing: 378 }
    ]
  }
};

// Crop yield data (tonnes per hectare)
export const cropYieldData = {
  Wheat: {
    ON: [
      { year: 2015, yield: 3.2, area: 425000, production: 1360000 },
      { year: 2016, yield: 3.5, area: 445000, production: 1557500 },
      { year: 2017, yield: 2.9, area: 398000, production: 1154200 },
      { year: 2018, yield: 3.8, area: 467000, production: 1774600 },
      { year: 2019, yield: 3.3, area: 423000, production: 1395900 },
      { year: 2020, yield: 3.7, area: 456000, production: 1687200 },
      { year: 2021, yield: 3.4, area: 434000, production: 1475600 },
      { year: 2022, yield: 3.1, area: 412000, production: 1277200 },
      { year: 2023, yield: 3.9, area: 478000, production: 1864200 },
      { year: 2024, yield: 3.6, area: 445000, production: 1602000 }
    ],
    SK: [
      { year: 2015, yield: 2.8, area: 4560000, production: 12768000 },
      { year: 2016, yield: 3.1, area: 4623000, production: 14331300 },
      { year: 2017, yield: 2.4, area: 4234000, production: 10161600 },
      { year: 2018, yield: 3.4, area: 4789000, production: 16282600 },
      { year: 2019, yield: 2.9, area: 4512000, production: 13084800 },
      { year: 2020, yield: 3.3, area: 4701000, production: 15513300 },
      { year: 2021, yield: 3.0, area: 4623000, production: 13869000 },
      { year: 2022, yield: 2.7, area: 4456000, production: 12031200 },
      { year: 2023, yield: 3.5, area: 4834000, production: 16919000 },
      { year: 2024, yield: 3.2, area: 4667000, production: 14934400 }
    ],
    AB: [
      { year: 2015, yield: 3.1, area: 2890000, production: 8959000 },
      { year: 2016, yield: 3.4, area: 2934000, production: 9975600 },
      { year: 2017, yield: 2.7, area: 2756000, production: 7441200 },
      { year: 2018, yield: 3.6, area: 3012000, production: 10843200 },
      { year: 2019, yield: 3.2, area: 2867000, production: 9174400 },
      { year: 2020, yield: 3.5, area: 2978000, production: 10423000 },
      { year: 2021, yield: 3.3, area: 2901000, production: 9573300 },
      { year: 2022, yield: 2.9, area: 2823000, production: 8186700 },
      { year: 2023, yield: 3.7, area: 3056000, production: 11307200 },
      { year: 2024, yield: 3.4, area: 2945000, production: 10013000 }
    ],
    MB: [
      { year: 2015, yield: 2.9, area: 1234000, production: 3578600 },
      { year: 2016, yield: 3.2, area: 1267000, production: 4054400 },
      { year: 2017, yield: 2.6, area: 1189000, production: 3091400 },
      { year: 2018, yield: 3.4, area: 1301000, production: 4423400 },
      { year: 2019, yield: 3.0, area: 1245000, production: 3735000 },
      { year: 2020, yield: 3.3, area: 1278000, production: 4217400 },
      { year: 2021, yield: 3.1, area: 1256000, production: 3893600 },
      { year: 2022, yield: 2.8, area: 1223000, production: 3424400 },
      { year: 2023, yield: 3.5, area: 1312000, production: 4592000 },
      { year: 2024, yield: 3.2, area: 1267000, production: 4054400 }
    ]
  },
  Canola: {
    ON: [
      { year: 2015, yield: 2.1, area: 78000, production: 163800 },
      { year: 2016, yield: 2.3, area: 82000, production: 188600 },
      { year: 2017, yield: 1.9, area: 74000, production: 140600 },
      { year: 2018, yield: 2.4, area: 86000, production: 206400 },
      { year: 2019, yield: 2.2, area: 81000, production: 178200 },
      { year: 2020, yield: 2.5, area: 89000, production: 222500 },
      { year: 2021, yield: 2.3, area: 84000, production: 193200 },
      { year: 2022, yield: 2.0, area: 78000, production: 156000 },
      { year: 2023, yield: 2.6, area: 92000, production: 239200 },
      { year: 2024, yield: 2.4, area: 87000, production: 208800 }
    ],
    SK: [
      { year: 2015, yield: 1.8, area: 4234000, production: 7621200 },
      { year: 2016, yield: 2.0, area: 4356000, production: 8712000 },
      { year: 2017, yield: 1.6, area: 4012000, production: 6419200 },
      { year: 2018, yield: 2.1, area: 4445000, production: 9334500 },
      { year: 2019, yield: 1.9, area: 4223000, production: 8023700 },
      { year: 2020, yield: 2.0, area: 4367000, production: 8734000 },
      { year: 2021, yield: 1.9, area: 4289000, production: 8149100 },
      { year: 2022, yield: 1.7, area: 4134000, production: 7027800 },
      { year: 2023, yield: 2.2, area: 4456000, production: 9803200 },
      { year: 2024, yield: 2.0, area: 4334000, production: 8668000 }
    ],
    AB: [
      { year: 2015, yield: 1.9, area: 2567000, production: 4877300 },
      { year: 2016, yield: 2.1, area: 2634000, production: 5531400 },
      { year: 2017, yield: 1.7, area: 2456000, production: 4175200 },
      { year: 2018, yield: 2.2, area: 2689000, production: 5915800 },
      { year: 2019, yield: 2.0, area: 2601000, production: 5202000 },
      { year: 2020, yield: 2.1, area: 2678000, production: 5623800 },
      { year: 2021, yield: 2.0, area: 2645000, production: 5290000 },
      { year: 2022, yield: 1.8, area: 2523000, production: 4541400 },
      { year: 2023, yield: 2.3, area: 2712000, production: 6237600 },
      { year: 2024, yield: 2.1, area: 2656000, production: 5577600 }
    ],
    MB: [
      { year: 2015, yield: 1.7, area: 1456000, production: 2475200 },
      { year: 2016, yield: 1.9, area: 1489000, production: 2829100 },
      { year: 2017, yield: 1.5, area: 1398000, production: 2097000 },
      { year: 2018, yield: 2.0, area: 1523000, production: 3046000 },
      { year: 2019, yield: 1.8, area: 1467000, production: 2640600 },
      { year: 2020, yield: 1.9, area: 1501000, production: 2851900 },
      { year: 2021, yield: 1.8, area: 1478000, production: 2660400 },
      { year: 2022, yield: 1.6, area: 1434000, production: 2294400 },
      { year: 2023, yield: 2.1, area: 1534000, production: 3221400 },
      { year: 2024, yield: 1.9, area: 1489000, production: 2829100 }
    ]
  },
  Corn: {
    ON: [
      { year: 2015, yield: 9.2, area: 891000, production: 8197200 },
      { year: 2016, yield: 9.8, area: 923000, production: 9045400 },
      { year: 2017, yield: 8.6, area: 867000, production: 7496200 },
      { year: 2018, yield: 10.1, area: 945000, production: 9544500 },
      { year: 2019, yield: 9.5, area: 912000, production: 8664000 },
      { year: 2020, yield: 9.9, area: 934000, production: 9246600 },
      { year: 2021, yield: 9.7, area: 921000, production: 8933700 },
      { year: 2022, yield: 8.9, area: 889000, production: 7912100 },
      { year: 2023, yield: 10.3, area: 956000, production: 9846800 },
      { year: 2024, yield: 9.8, area: 931000, production: 9123800 }
    ],
    SK: [
      { year: 2015, yield: 6.8, area: 34000, production: 231200 },
      { year: 2016, yield: 7.2, area: 36000, production: 259200 },
      { year: 2017, yield: 6.1, area: 32000, production: 195200 },
      { year: 2018, yield: 7.5, area: 38000, production: 285000 },
      { year: 2019, yield: 6.9, area: 35000, production: 241500 },
      { year: 2020, yield: 7.3, area: 37000, production: 270100 },
      { year: 2021, yield: 7.0, area: 36000, production: 252000 },
      { year: 2022, yield: 6.4, area: 34000, production: 217600 },
      { year: 2023, yield: 7.6, area: 39000, production: 296400 },
      { year: 2024, yield: 7.2, area: 37000, production: 266400 }
    ],
    AB: [
      { year: 2015, yield: 7.1, area: 67000, production: 475700 },
      { year: 2016, yield: 7.5, area: 71000, production: 532500 },
      { year: 2017, yield: 6.6, area: 63000, production: 415800 },
      { year: 2018, yield: 7.8, area: 74000, production: 577200 },
      { year: 2019, yield: 7.3, area: 69000, production: 503700 },
      { year: 2020, yield: 7.6, area: 72000, production: 547200 },
      { year: 2021, yield: 7.4, area: 70000, production: 518000 },
      { year: 2022, yield: 6.9, area: 67000, production: 462300 },
      { year: 2023, yield: 7.9, area: 75000, production: 592500 },
      { year: 2024, yield: 7.5, area: 72000, production: 540000 }
    ],
    MB: [
      { year: 2015, yield: 8.3, area: 145000, production: 1203500 },
      { year: 2016, yield: 8.7, area: 152000, production: 1322400 },
      { year: 2017, yield: 7.8, area: 138000, production: 1076400 },
      { year: 2018, yield: 9.0, area: 158000, production: 1422000 },
      { year: 2019, yield: 8.5, area: 147000, production: 1249500 },
      { year: 2020, yield: 8.8, area: 154000, production: 1355200 },
      { year: 2021, yield: 8.6, area: 149000, production: 1281400 },
      { year: 2022, yield: 8.1, area: 143000, production: 1158300 },
      { year: 2023, yield: 9.1, area: 161000, production: 1465100 },
      { year: 2024, yield: 8.7, area: 154000, production: 1339800 }
    ]
  },
  Soybeans: {
    ON: [
      { year: 2015, yield: 2.8, area: 1234000, production: 3455200 },
      { year: 2016, yield: 3.1, area: 1267000, production: 3927700 },
      { year: 2017, yield: 2.6, area: 1189000, production: 3091400 },
      { year: 2018, yield: 3.2, area: 1301000, production: 4163200 },
      { year: 2019, yield: 2.9, area: 1245000, production: 3610500 },
      { year: 2020, yield: 3.3, area: 1278000, production: 4217400 },
      { year: 2021, yield: 3.0, area: 1256000, production: 3768000 },
      { year: 2022, yield: 2.7, area: 1223000, production: 3302100 },
      { year: 2023, yield: 3.4, area: 1312000, production: 4460800 },
      { year: 2024, yield: 3.1, area: 1267000, production: 3927700 }
    ],
    SK: [
      { year: 2015, yield: 2.1, area: 89000, production: 186900 },
      { year: 2016, yield: 2.3, area: 92000, production: 211600 },
      { year: 2017, yield: 1.9, area: 84000, production: 159600 },
      { year: 2018, yield: 2.4, area: 96000, production: 230400 },
      { year: 2019, yield: 2.2, area: 89000, production: 195800 },
      { year: 2020, yield: 2.5, area: 94000, production: 235000 },
      { year: 2021, yield: 2.3, area: 91000, production: 209300 },
      { year: 2022, yield: 2.0, area: 87000, production: 174000 },
      { year: 2023, yield: 2.6, area: 98000, production: 254800 },
      { year: 2024, yield: 2.4, area: 93000, production: 223200 }
    ],
    AB: [
      { year: 2015, yield: 2.2, area: 78000, production: 171600 },
      { year: 2016, yield: 2.4, area: 82000, production: 196800 },
      { year: 2017, yield: 2.0, area: 74000, production: 148000 },
      { year: 2018, yield: 2.5, area: 86000, production: 215000 },
      { year: 2019, yield: 2.3, area: 81000, production: 186300 },
      { year: 2020, yield: 2.6, area: 84000, production: 218400 },
      { year: 2021, yield: 2.4, area: 83000, production: 199200 },
      { year: 2022, yield: 2.1, area: 79000, production: 165900 },
      { year: 2023, yield: 2.7, area: 87000, production: 234900 },
      { year: 2024, yield: 2.5, area: 84000, production: 210000 }
    ],
    MB: [
      { year: 2015, yield: 2.5, area: 167000, production: 417500 },
      { year: 2016, yield: 2.7, area: 174000, production: 469800 },
      { year: 2017, yield: 2.3, area: 158000, production: 363400 },
      { year: 2018, yield: 2.8, area: 181000, production: 506800 },
      { year: 2019, yield: 2.6, area: 169000, production: 439400 },
      { year: 2020, yield: 2.9, area: 176000, production: 510400 },
      { year: 2021, yield: 2.7, area: 172000, production: 464400 },
      { year: 2022, yield: 2.4, area: 165000, production: 396000 },
      { year: 2023, yield: 3.0, area: 184000, production: 552000 },
      { year: 2024, yield: 2.8, area: 177000, production: 495600 }
    ]
  }
};

// 2025 Predictions (mock forecasting results)
export const predictions2025 = {
  Wheat: {
    ON: { yield: 3.7, area: 452000, production: 1672400, confidence: 0.85 },
    SK: { yield: 3.3, area: 4712000, production: 15549600, confidence: 0.82 },
    AB: { yield: 3.5, area: 2987000, production: 10454500, confidence: 0.84 },
    MB: { yield: 3.3, area: 1278000, production: 4217400, confidence: 0.86 }
  },
  Canola: {
    ON: { yield: 2.5, area: 89000, production: 222500, confidence: 0.83 },
    SK: { yield: 2.1, area: 4389000, production: 9216900, confidence: 0.81 },
    AB: { yield: 2.2, area: 2667000, production: 5867400, confidence: 0.85 },
    MB: { yield: 2.0, area: 1501000, production: 3002000, confidence: 0.84 }
  },
  Corn: {
    ON: { yield: 10.0, area: 945000, production: 9450000, confidence: 0.87 },
    SK: { yield: 7.4, area: 38000, production: 281200, confidence: 0.79 },
    AB: { yield: 7.7, area: 74000, production: 569800, confidence: 0.81 },
    MB: { yield: 8.9, area: 156000, production: 1388400, confidence: 0.86 }
  },
  Soybeans: {
    ON: { yield: 3.2, area: 1289000, production: 4124800, confidence: 0.88 },
    SK: { yield: 2.5, area: 95000, production: 237500, confidence: 0.80 },
    AB: { yield: 2.6, area: 86000, production: 223600, confidence: 0.82 },
    MB: { yield: 2.9, area: 179000, production: 519100, confidence: 0.85 }
  }
};

// Weather forecast for 2025 (mock)
export const weatherForecast2025 = {
  ON: { avgTemp: 9.4, totalPrecip: 812, growingPrecip: 456, extremeHeat: 3, extremeCold: 2 },
  SK: { avgTemp: 4.1, totalPrecip: 412, growingPrecip: 295, extremeHeat: 5, extremeCold: 4 },
  AB: { avgTemp: 5.8, totalPrecip: 489, growingPrecip: 345, extremeHeat: 4, extremeCold: 3 },
  MB: { avgTemp: 4.9, totalPrecip: 556, growingPrecip: 389, extremeHeat: 3, extremeCold: 3 }
};

// National totals calculation helper
export const calculateNationalTotals = (cropData) => {
  const nationalData = [];
  
  for (let year = 2015; year <= 2024; year++) {
    let totalProduction = 0;
    let totalArea = 0;
    
    provinces.forEach(province => {
      const provinceData = cropData[province.id];
      if (provinceData) {
        const yearData = provinceData.find(d => d.year === year);
        if (yearData) {
          totalProduction += yearData.production;
          totalArea += yearData.area;
        }
      }
    });
    
    nationalData.push({
      year,
      production: totalProduction,
      area: totalArea,
      yield: totalProduction / totalArea
    });
  }
  
  return nationalData;
};

// Regional weather map data
export const weatherMapData = [
  { province: 'ON', lat: 44.2619, lng: -78.2624, temp: 9.2, precip: 798, risk: 'Low' },
  { province: 'SK', lat: 52.9399, lng: -106.4509, temp: 3.9, precip: 398, risk: 'Medium' },
  { province: 'AB', lat: 53.9333, lng: -116.5765, temp: 5.5, precip: 478, risk: 'Low' },
  { province: 'MB', lat: 53.7609, lng: -98.8139, temp: 4.6, precip: 534, risk: 'Medium' }
];